export default __webpack_public_path__ + "static/media/Gabriela_Rivera.63df15ed.png";